import { Helmet } from 'react-helmet-async';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import { IoCheckmarkCircleOutline } from "react-icons/io5";

const IndustryExperts = () => {
    return (
        <section className='w-full bg-cover h-fit pb-5'>

            <Helmet>
                <title>Industry Experts</title>
                <meta name="description" content="Learn more about MIJSC, our mission, vision, and commitment to excellence." />
            </Helmet>
            <BreadCrumbs />
            <div className=' w-[94%] text-justify'>
                <section className='w-full h-fit md:mx-10 mx-5 mb-5 ' >
                    <h1 className="md:text-4xl text-lg my-5 font-semibold  uppercase text-left">Industry <br />
                        <span className="text-green-600">Experts</span>
                    </h1>
                </section>
            </div>
            <section className="py-10 px-5 md:px-10 lg:px-16 bg-white">
                <div className="max-w-7xl mx-auto mb-10">
                    <div className="mb-20 grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-28 items-center">
                        <div className="md:col-span-4 relative">
                            <figure className="relative w-full rounded-[30px] overflow-hidden shadow-[0_30px_60px_rgba(15,23,36,0.15)] border border-black/5 h-[240px] md:h-[260px] bg-gray-50">
                                <img
                                    src="/assets/industri-expert/amar-telang.jpg"
                                    alt="Amar K. Telang"
                                    className="w-full h-full object-contain"
                                />
                            </figure>
                            {/* Floating Card */}
                            <div className="hidden md:block absolute -right-20  w-[260px] -bottom-8 bg-white shadow-xl rounded-2xl px-4 py-3">
                                <div className="flex items-center gap-3">
                                    <div className="w-10 h-10 rounded-xl">
                                        <div className="w-full h-full bg-green-700 bg-no-repeat bg-center bg-contain" style={{ backgroundImage: "url('/assets/user-icon.png')", borderRadius: '6px' }} />
                                    </div>

                                    <div>
                                        <div className="font-semibold text-gray-800 text-md">
                                            Amar K. Telang
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="md:col-span-8">
                            <div className="flex gap-3 items-start mt-3">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className="font-bold text-sm text-gray-600">
                                    Coach, mentor, consultant and auditor for Management System Standards.
                                </p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'> Mentor for Flow Transformation. </p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'>Implementer & Auditor for carbon footprint management.</p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'> Certified Sustainability (ESG) Professional. </p>
                            </div>
                        </div>
                    </div>

                    <div className="mb-20 grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-28 items-center">
                        <div className="md:col-span-4 relative">
                            <figure className="relative w-full rounded-[30px] overflow-hidden shadow-[0_30px_60px_rgba(15,23,36,0.15)] border border-black/5 h-[240px] md:h-[260px]">
                                <img
                                    src="/assets/industri-expert/dr-abhilash-pathania.jpg"
                                    alt="Saideep Rathnam"
                                    className="w-full h-full object-contain"
                                />
                            </figure>
                            <div className="hidden md:block absolute -right-20  w-[260px] -bottom-8 bg-white shadow-xl rounded-2xl px-4 py-3">
                                <div className="flex items-center gap-3">
                                    <div className="w-10 h-10 rounded-xl">
                                        <div className="w-full h-full bg-green-700 bg-no-repeat bg-center bg-contain" style={{ backgroundImage: "url('/assets/user-icon.png')", borderRadius: '6px' }} />
                                    </div>

                                    <div>
                                        <div className="font-semibold text-gray-800 text-sm">
                                            Dr. Abhilash Pathania
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Content (col-md-8) */}
                        <div className="md:col-span-8">
                            <div className="flex gap-3 items-center mt-3">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-bold text-sm  text-gray-600'> Academician and Researcher.</p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'> Patent Filer. </p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'>VLCI Coordinator and trainer.</p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'> Lean Consultant. </p>
                            </div>
                        </div>
                    </div>

                    <div className="mb-20 grid grid-cols-1 md:grid-cols-12 gap-6 items-center">
                        {/* Content (col-md-8) */}
                        <div className="md:col-span-8">
                            <div className="flex gap-3 items-center mt-3">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-bold text-sm  text-gray-600'>Coach, mentor, and consultant for Manufacturing sector and investment banking. </p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'>Curator and trainer of Leadership Development Programs.  </p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'>Faculty of VLCI, VLFM and Product Development. </p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'>Authored several case studies on Manufacturing Excellence and Organization Transformation . </p>
                            </div>
                        </div>
                        <div className="md:col-span-4 relative">
                            <figure className="relative w-full rounded-[30px] overflow-hidden shadow-[0_30px_60px_rgba(15,23,36,0.15)] border border-black/5 h-[240px] md:h-[260px]">
                                <img
                                    src="/assets/industri-expert/kalpana-narain.jpg"
                                    alt="Saideep Rathnam"
                                    className="w-full h-full object-contain"
                                />
                            </figure>
                            <div className="hidden md:block absolute -left-10 -bottom-8 w-[260px] bg-white shadow-xl rounded-2xl px-4 py-2">
                                <div className="flex items-center gap-3">
                                    <div className="w-10 h-10 rounded-xl">
                                        <div className="w-full h-full bg-green-700 bg-no-repeat bg-center bg-contain" style={{ backgroundImage: "url('/assets/user-icon.png')", borderRadius: '6px' }} />
                                    </div>

                                    <div>
                                        <div className="font-semibold text-gray-800 text-sm">
                                            Kalpana Narain
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="mb-20 grid grid-cols-1 md:grid-cols-12 gap-6  items-center">


                        {/* Content (col-md-8) */}
                        <div className="md:col-span-8">
                            <div className="flex gap-3 items-center mt-3">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-bold text-sm  text-gray-600'>Senior General Manager, Head Lean, Bosch India. </p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'>Manufacturing and Lean Expert.  </p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'>Head of Technical purchasing with knowledge in corporate purchasing. </p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'>Certified Lean Six Sigma Green Belt from KPMG and Speed week Coach. </p>
                            </div>
                            <div className="flex gap-3 items-center mt-3">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-bold text-sm  text-gray-600'>Qualified Toyota Kata Coach. </p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'>Certified Head Assessor.  </p>
                            </div>
                        </div>

                        <div className="md:col-span-4 relative">
                            <figure className="relative w-full rounded-[30px] overflow-hidden shadow-[0_30px_60px_rgba(15,23,36,0.15)] border border-black/5 h-[240px] md:h-[260px]">
                                <img
                                    src="/assets/industri-expert/sk-ramesh.jpg"
                                    alt="Saideep Rathnam"
                                    className="w-full h-full object-contain"
                                />
                            </figure>
                            <div className="hidden md:block absolute -left-10 -bottom-8 w-[260px] bg-white shadow-xl rounded-2xl px-4 py-2">
                                <div className="flex items-center gap-3">
                                    <div className="w-10 h-10 rounded-xl">
                                        <div className="w-full h-full bg-green-700 bg-no-repeat bg-center bg-contain" style={{ backgroundImage: "url('/assets/user-icon.png')", borderRadius: '6px' }} />
                                    </div>

                                    <div>
                                        <div className="font-semibold text-gray-800 text-sm">
                                            S. K. Ramesh
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="mb-20 grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-28 items-center">
                        <div className="md:col-span-4 relative">
                            <figure className="relative w-full rounded-[30px] overflow-hidden shadow-[0_30px_60px_rgba(15,23,36,0.15)] border border-black/5 h-[240px] md:h-[260px]">
                                <img
                                    src="/assets/industri-expert/narayan-vakil.jpg"
                                    alt="Saideep Rathnam"
                                    className="w-full h-full object-contain"
                                />
                            </figure>
                            <div className="hidden md:block absolute -right-20  w-[260px] -bottom-8 bg-white shadow-xl rounded-2xl px-4 py-3">
                                <div className="flex items-center gap-3">
                                    <div className="w-10 h-10 rounded-xl">
                                        <div className="w-full h-full bg-green-700 bg-no-repeat bg-center bg-contain" style={{ backgroundImage: "url('/assets/user-icon.png')", borderRadius: '6px' }} />
                                    </div>

                                    <div>
                                        <div className="font-semibold text-gray-800 text-sm">
                                            Narayan Vakil
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Content (col-md-8) */}
                        <div className="md:col-span-8">
                            <div className="flex gap-3 items-center mt-3">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-bold text-sm  text-gray-600'>Industry Expertise: Auto/Machine/Defence areas. </p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'>Axle & Driveshaft Design Manufacturing .  </p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'>Founder Parth Consultancy. </p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'>VLCI Certified Coach. </p>
                            </div>
                        </div>
                    </div>

                    <div className="mb-20 grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-28 items-center">
                        <div className="md:col-span-4 relative">
                            <figure className="relative w-full rounded-[30px] overflow-hidden shadow-[0_30px_60px_rgba(15,23,36,0.15)] border border-black/5 h-[240px] md:h-[260px]">
                                <img
                                    src="/assets/industri-expert/prakash-mugali.jpg"
                                    alt="Saideep Rathnam"
                                    className="w-full h-full object-contain"
                                />
                            </figure>
                            <div className="hidden md:block absolute -right-20  w-[260px] -bottom-8 bg-white shadow-xl rounded-2xl px-4 py-3">
                                <div className="flex items-center gap-3">
                                    <div className="w-10 h-10 rounded-xl">
                                        <div className="w-full h-full bg-green-700 bg-no-repeat bg-center bg-contain" style={{ backgroundImage: "url('/assets/user-icon.png')", borderRadius: '6px' }} />
                                    </div>

                                    <div>
                                        <div className="font-semibold text-gray-800 text-sm">
                                            Prakash Mugali
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Content (col-md-8) */}
                        <div className="md:col-span-8">
                            <div className="flex gap-3 items-center mt-3">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-bold text-sm  text-gray-600'>Founder Enerzy Group: Leaders in Microwave Technology. </p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'> Certified Leadership Coach. </p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'> Certified Independent Director.</p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'>Globally recognized Innovator. </p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'>India’s top SME Innovator -2019.  </p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'>India’s SME 100 Award -2019 </p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'>VLCI Certified Coach </p>
                            </div>
                        </div>
                    </div>

                    <div className="mb-20 grid grid-cols-1 md:grid-cols-12 gap-6  items-center">


                        {/* Content (col-md-8) */}
                        <div className="md:col-span-8">
                            <div className="flex gap-3 items-center mt-3">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-bold text-sm  text-gray-600'>Consultant and Coach for Lean Manufacturing Practices. </p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'>Manufacturing and Lean expert.  </p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'>Mentor of VLFM, VSME, VLCI (LMP) Programs. </p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'>Founder of EKAM Consultants. </p>
                            </div>
                        </div>


                        <div className="md:col-span-4 relative">
                            <figure className="relative w-full rounded-[30px] overflow-hidden shadow-[0_30px_60px_rgba(15,23,36,0.15)] border border-black/5 h-[240px] md:h-[260px]">
                                <img
                                    src="/assets/industri-expert/subodh-korde.jpg"
                                    alt="Saideep Rathnam"
                                    className="w-full h-full object-contain"
                                />
                            </figure>
                            <div className="hidden md:block absolute -left-10 -bottom-8 w-[260px] bg-white shadow-xl rounded-2xl px-4 py-2">
                                <div className="flex items-center gap-3">
                                    <div className="w-10 h-10 rounded-xl">
                                        <div className="w-full h-full bg-green-700 bg-no-repeat bg-center bg-contain" style={{ backgroundImage: "url('/assets/user-icon.png')", borderRadius: '6px' }} />
                                    </div>

                                    <div>
                                        <div className="font-semibold text-gray-800 text-sm">
                                            Subodh Korde
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="mb-20 grid grid-cols-1 md:grid-cols-12 gap-6 items-center">


                        {/* Content (col-md-8) */}
                        <div className="md:col-span-8">
                            <div className="flex gap-3 items-center mt-3">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-bold text-sm  text-gray-600'>Founder Creintors Group of Companies: Creintors – shortlisted for National Startup Award -2021. </p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'>Innovator / Entrepreneur.  </p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'>Product Innovation Award -2019. </p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'> VLFM Certified Coach. </p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'> VLCI Certified Coach. </p>
                            </div>
                        </div>

                        <div className="md:col-span-4 relative">
                            <figure className="relative w-full rounded-[30px] overflow-hidden shadow-[0_30px_60px_rgba(15,23,36,0.15)] border border-black/5 h-[240px] md:h-[260px]">
                                <img
                                    src="/assets/industri-expert/neelesh-chougule.jpg"
                                    alt="Saideep Rathnam"
                                    className="w-full h-full object-contain"
                                />
                            </figure>
                            <div className="hidden md:block absolute -left-10 -bottom-8 w-[260px] bg-white shadow-xl rounded-2xl px-4 py-2">
                                <div className="flex items-center gap-3">
                                    <div className="w-10 h-10 rounded-xl">
                                        <div className="w-full h-full bg-green-700 bg-no-repeat bg-center bg-contain" style={{ backgroundImage: "url('/assets/user-icon.png')", borderRadius: '6px' }} />
                                    </div>

                                    <div>
                                        <div className="font-semibold text-gray-800 text-sm">
                                            Neelesh Chougule
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="mb-20 grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-28 items-center">
                        <div className="md:col-span-4 relative">
                            <figure className="relative w-full rounded-[30px] overflow-hidden shadow-[0_30px_60px_rgba(15,23,36,0.15)] border border-black/5 h-[240px] md:h-[260px]">
                                <img
                                    src="/assets/industri-expert/tan-singh-rana.jpg"
                                    alt="Saideep Rathnam"
                                    className="w-full h-full object-contain"
                                />
                            </figure>
                            <div className="hidden md:block absolute -right-20  w-[260px] -bottom-8 bg-white shadow-xl rounded-2xl px-4 py-3">
                                <div className="flex items-center gap-3">
                                    <div className="w-10 h-10 rounded-xl">
                                        <div className="w-full h-full bg-green-700 bg-no-repeat bg-center bg-contain" style={{ backgroundImage: "url('/assets/user-icon.png')", borderRadius: '6px' }} />
                                    </div>
                                    <div>
                                        <div className="font-semibold text-gray-800 text-sm">
                                            Tan Singh Rana
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Content (col-md-8) */}
                        <div className="md:col-span-8">
                            <div className="flex gap-3 items-center mt-3">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-bold text-sm  text-gray-600'>Coach, mentor, consultant and expert in Manufacturing (Flow Management Tools). </p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'>VLCI demonstrator and consultant.  </p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'>Industry & Academic instructor in Flow Concepts. </p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'>Certified Level 3 Flow Professional. </p>
                            </div>
                        </div>
                    </div>


                    <div className="mb-20 grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-28 items-center">
                        <div className="md:col-span-4 relative">
                            <figure className="relative w-full rounded-[30px] overflow-hidden shadow-[0_30px_60px_rgba(15,23,36,0.15)] border border-black/5 h-[240px] md:h-[260px]">
                                <img
                                    src="/assets/industri-expert/dilip-gopalrao-palve.jpg"
                                    alt="Dilip Gopalrao Palve"
                                    className="w-full h-full object-contain"
                                />
                            </figure>
                            <div className="hidden md:block absolute -right-20  w-[260px] -bottom-8 bg-white shadow-xl rounded-2xl px-4 py-3">
                                <div className="flex items-center gap-3">
                                    <div className="w-10 h-10 rounded-xl">
                                        <div className="w-full h-full bg-green-700 bg-no-repeat bg-center bg-contain" style={{ backgroundImage: "url('/assets/user-icon.png')", borderRadius: '6px' }} />
                                    </div>

                                    <div>
                                        <div className="font-semibold text-gray-800 text-sm">
                                            Dilip Gopalrao  Palve
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Content (col-md-8) */}
                        <div className="md:col-span-8">
                            <div className="flex gap-3 items-center mt-3">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-bold text-sm  text-gray-600'>Expertise in Automotive Manufacturing, Operational Excellence & SCM </p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'> Strategic Planning and Implementation </p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'> Operations and Plant Management</p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'>Lean Demonstrator and Consultant </p>
                            </div>

                        </div>
                    </div>



                    <div className="mb-20 grid grid-cols-1 md:grid-cols-12 gap-6 items-center">


                        {/* Content (col-md-8) */}
                        <div className="md:col-span-8">
                            <div className="flex gap-3 items-center mt-3">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-bold text-sm  text-gray-600'>Anand Corporate Trainer for 32 Years
                                </p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'>Master Black Belt Six Sigma</p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'>VLFM coach </p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'>TPM from Behr Germany </p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'>Indian Society for Training &  Development Chapter Incharge Chandigarh</p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'>QCFI Life Member &Certified Mentor  </p>
                            </div>
                            <div className="flex gap-3 items-center">
                                <IoCheckmarkCircleOutline className="text-green-600 w-5 h-5 shrink-0 mt-0.5" />
                                <p className='font-semibold text-sm my-2 text-gray-600'>Jury Member For QIMPRO Quality Award</p>
                            </div>
                        </div>

                        <div className="md:col-span-4 relative">
                            <figure className="relative w-full rounded-[30px] overflow-hidden shadow-[0_30px_60px_rgba(15,23,36,0.15)] border border-black/5 h-[240px] md:h-[260px]">
                                <img
                                    src="/assets/industri-expert/ratnakar-acharya.jpg"
                                    alt="Ratnakar Acharya"
                                    className="w-full h-full object-contain"
                                />
                            </figure>
                            <div className="hidden md:block absolute -left-10 -bottom-8 w-[260px] bg-white shadow-xl rounded-2xl px-4 py-2">
                                <div className="flex items-center gap-3">
                                    <div className="w-10 h-10 rounded-xl">
                                        <div className="w-full h-full bg-green-700 bg-no-repeat bg-center bg-contain" style={{ backgroundImage: "url('/assets/user-icon.png')", borderRadius: '6px' }} />
                                    </div>

                                    <div>
                                        <div className="font-semibold text-gray-800 text-sm">
                                            Ratnakar Acharya
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>




                </div>
            </section>

        </section>
    )
}

export default IndustryExperts
